import { Component, OnDestroy, OnInit,ViewChild, ViewChildren, QueryList, ChangeDetectorRef, ElementRef, Input , Pipe, PipeTransform, Output, EventEmitter , ViewEncapsulation,AfterViewInit } from '@angular/core';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, FormControl, UntypedFormGroup } from '@angular/forms';
import { interval, Subscription } from 'rxjs';
import { debounceTime, map, distinctUntilChanged } from 'rxjs/operators';

import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { ActivatedRoute, Router } from '@angular/router';

import { CustomerService } from '../../../services/customer.service';
import { GlobalsService } from '../../../services/globals.service';
import { GlobalSearchService } from '../../../services/globalsearchservice.service';
import { trigger, state, style, transition, animate , query, group, stagger } from '@angular/animations';
import { Customer } from '../../../classes/customer';
import { Location } from '@angular/common'
import { SpeechRecognitionService, SpeechRecognitionResult } from '../../../services/speech-recognition.service';

@Component({
	selector: 'app-customer-notes',
	templateUrl: './customer-notes.component.html',
	styleUrls: ['./customer-notes.component.scss'],
	animations: [
		trigger('grow', [ // Note the trigger name
			transition(':enter', [
				// :enter is alias to 'void => *'
				style({ height: '0',width: '0' }),
				animate(200, style({ height: '*' , width: '*' })),
				animate('200ms', style({ opacity: 1 })),
			]),
			transition(':leave', [
				// :leave is alias to '* => void'
				animate(300, style({ height: 0, width: 0  })),
				animate('300ms', style({ opacity: 0 }))
			])
		]),
	]
})
export class CustomerNotesComponent implements OnInit {
	@Input() customer;
	@Output() editing = new EventEmitter<boolean>();
	@Output() newcustomerdata = new EventEmitter<boolean>();
	user: any = []
	noteFrom: UntypedFormGroup;
	notes: any = []
	newnote_id = 0;
	default_type ='ORDER';
	notetypes = ['ORDER','POS','BACK_OFFICE','AR','INTERNAL','DISPATCH','SHIP'];
	removals: any = [];
	editingnote: any = false;
	@ViewChildren('noteInput') noteInputs: QueryList<ElementRef<HTMLInputElement>>;
	isVoiceRecordingNote = false;
	currentVoiceNoteId: number | null = null;
	voiceSubscription: Subscription | null = null;
	voiceErrorSubscription: Subscription | null = null;
	voiceListeningSubscription: Subscription | null = null;
	confirmedVoiceText = '';
	sttDebug = false;

	constructor(private route: ActivatedRoute, private fb: UntypedFormBuilder,private customerService: CustomerService, public router: Router, private location: Location, private globalsService: GlobalsService, public globalSearchService: GlobalSearchService, private cdr: ChangeDetectorRef, public speechRecognitionService?: SpeechRecognitionService) {

	}

	addNote() {
		this.editingnote = true;
		this.newnote_id = this.newnote_id - 1;
		const newNote ={
			debtorno: this.customer.debtorno,
			noteid: this.newnote_id,
			note: '',
			note_code: this.notetypes[0],
		}

		this.customer.notes.push(newNote)
	}

	updateNote(event:any, note: any) {
		const index = this.customer.notes.indexOf(note);
		this.customer.notes[index].note = event.target.value;
	}

	removeNote(id: any) {
		this.removals.push(id)
		this.customer.notes = this.customer.notes.filter( (note) => {
			return note.noteid != id;
		});
	}

	onSubmit() {

		// Prevent saving if any empty note exists
		const firstEmpty = this.customer.notes.find((n: any) => !n || !String(n.note || '').trim());
		if (firstEmpty) {
			this.globalSearchService.showNotification('Please fill in or remove empty notes before saving.', 'error', 'bottom', 'right');
			// Focus the first empty note input if possible
			if (firstEmpty.noteid != null && typeof this.focusNoteInput === 'function') {
				this.focusNoteInput(firstEmpty.noteid);
			}
			return;
		}

		// Proceed with updating debtor notes
		this.customerService.updateDebtorNotes({ notes: this.customer.notes, removals: this.removals }).subscribe(
			(results) => {
				// Update customer notes and emit new customer data
				this.customer.notes = results.notes;
				this.newcustomerdata.emit(this.customer);
				this.editing.emit(false);
			},
			(error) => {
			}
		);
	}


	setForm() {

		this.newnote_id = this.newnote_id - 1;

		this.noteFrom = this.fb.group({
			debtorno: [this.customer.debtorno, Validators.required],
			noteid: [this.newnote_id, Validators.required],
			note: ['', Validators.required],
			note_code: [this.notetypes[0], Validators.required],
		});
	}

	back(): void {
		this.editing.emit(false);
	}

	updateTopic(event:any, note:any) {
		note.note_code =event.value
	}

	private focusNoteInput(noteId: number): void {
		if (!this.noteInputs) { return; }
		setTimeout(() => {
			const target = this.noteInputs.find(ref => ref?.nativeElement?.getAttribute('data-noteid') == String(noteId));
			if (target?.nativeElement) {
				target.nativeElement.focus();
				target.nativeElement.select();
			}
		}, 0);
	}

	private finalizeCurrentInterim(): void {
		if (this.currentVoiceNoteId == null) { return; }
		const note = this.customer?.notes?.find((n: any) => n.noteid === this.currentVoiceNoteId);
		if (!note) { return; }
		note.note = this.confirmedVoiceText || '';
	}

	private cleanupVoiceSubscriptionsOnly(): void {
		if (this.voiceSubscription) { this.voiceSubscription.unsubscribe(); this.voiceSubscription = null; }
		if (this.voiceErrorSubscription) { this.voiceErrorSubscription.unsubscribe(); this.voiceErrorSubscription = null; }
		if (this.voiceListeningSubscription) { this.voiceListeningSubscription.unsubscribe(); this.voiceListeningSubscription = null; }
		this.speechRecognitionService?.stopListening();
		this.speechRecognitionService?.setContinuous(false);
	}

	toggleVoiceAddNote(): void {
		if (this.isVoiceRecordingNote) {
			this.stopVoiceRecording();
		} else {
			this.finalizeCurrentInterim();
			this.addNote();
			const newNote = this.customer.notes[this.customer.notes.length - 1];
			this.currentVoiceNoteId = newNote.noteid;
			this.confirmedVoiceText = '';
			this.startVoiceRecording();
		}
	}

	toggleVoiceEditNote(note: any): void {
		if (this.isVoiceRecordingNote && this.currentVoiceNoteId === note.noteid) {
			this.stopVoiceRecording();
		} else {
			this.finalizeCurrentInterim();
			this.currentVoiceNoteId = note.noteid;
			this.confirmedVoiceText = note.note || '';
			this.startVoiceRecording();
		}
	}

	startVoiceRecording(): void {
		if (!this.speechRecognitionService?.getIsSupported()) {
			return;
		}

		this.cleanupVoiceSubscriptionsOnly();
		this.speechRecognitionService?.abortListening();

		this.speechRecognitionService.setContinuous(true);
		this.speechRecognitionService.setInterimResults(true);

		if (this.currentVoiceNoteId != null) {
			this.focusNoteInput(this.currentVoiceNoteId);
		}

		this.speechRecognitionService.requestMicrophonePermission().then((hasPermission) => {
			if (!hasPermission) {
				this.isVoiceRecordingNote = false;
				return;
			}

			this.voiceSubscription = this.speechRecognitionService.result$.subscribe((result: SpeechRecognitionResult | null) => {
				if (result && result.transcript.trim()) {
					const noteToUpdate = this.customer.notes.find((n: any) => n.noteid === this.currentVoiceNoteId);
					if (!noteToUpdate) { return; }

					if (result.isFinal) {
						this.confirmedVoiceText = this.confirmedVoiceText
							? `${this.confirmedVoiceText} ${result.transcript.trim()}`
							: result.transcript.trim();
						noteToUpdate.note = this.confirmedVoiceText;
						this.cdr.detectChanges();
					} else {
						const displayText = this.confirmedVoiceText
							? `${this.confirmedVoiceText} ${result.transcript.trim()}`
							: result.transcript.trim();
						noteToUpdate.note = displayText;
						this.cdr.detectChanges();
					}
				}
			});

			this.voiceErrorSubscription = this.speechRecognitionService.error$.subscribe(err => {
				if (err) { this.stopVoiceRecording(); }
			});

			this.voiceListeningSubscription = this.speechRecognitionService.isListening$.subscribe(listening => {
				this.isVoiceRecordingNote = listening && this.currentVoiceNoteId != null;
			});

			this.speechRecognitionService.startListening().catch(() => {
				this.stopVoiceRecording();
			});
		});
	}

	stopVoiceRecording(): void {
		if (this.voiceSubscription) { this.voiceSubscription.unsubscribe(); this.voiceSubscription = null; }
		if (this.voiceErrorSubscription) { this.voiceErrorSubscription.unsubscribe(); this.voiceErrorSubscription = null; }
		if (this.voiceListeningSubscription) { this.voiceListeningSubscription.unsubscribe(); this.voiceListeningSubscription = null; }
		this.speechRecognitionService?.stopListening();
		this.speechRecognitionService?.setContinuous(false);
		this.isVoiceRecordingNote = false;
		this.currentVoiceNoteId = null;
		this.confirmedVoiceText = '';
	}

	ngOnInit(): void {

		this.notes = this.customer.notes;
		if(!this.notes) {
			this.customer.notes = [];
			this.addNote();
		}
	}
	ngAfterViewInit() {
	}
}
